import { connect } from 'react-redux';
import { withStyles } from '@mui/styles';
import RequestDetails from './RequestDetails';
import styles from './styles';

function mapStateToProps(state) {
  const {
    isLoading, data, selectedRequest, error, message, itemsValidated,
  } = state.request;
  return {
    isLoading,
    data,
    selectedRequest,
    error,
    message,
    itemsValidated,
  };
}

const Styled = withStyles(styles)(RequestDetails);

export default connect(
  mapStateToProps,
)(Styled);
